import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setBriefing } from 'redux/briefing/briefingSlice';
import 'assets/scss/briefing.scss';
import CurrentBriefing from 'components/Briefing/currentBriefing';
import ControlPanel from "components/Briefing/oldBriefingControlPanel";
import { Toaster } from 'react-hot-toast';
import { _capitalise } from 'ag-grid-community';
import SafetyBriefing from 'components/Briefing/safety';
import { fetchTerminals } from 'redux/warehouse/terminalSlice';
import { setCurrentTerminal } from 'redux/warehouse/terminalSlice';

const Briefing = () => {
    const dispatch = useDispatch();

    const briefing = useSelector((state) => state.briefing);
    const terminals = useSelector((state) => state.TerminalSlice.terminals);
    const currentTerminal = useSelector((state) => state.TerminalSlice.currentTerminal);

    useEffect(() => {
        dispatch(fetchTerminals());
    }, [dispatch]);

    const handleBriefingClick = (newBriefing) => {
        dispatch(setBriefing(newBriefing));
    };

    // Wrapper component for rendering both ControlPanel and CurrentBriefing
    const ArchivesWrapper = () => (
        <>
            <ControlPanel />
            <CurrentBriefing />
        </>
    );

    const SafetyBriefingWrapper = () => (
        <>
            <ControlPanel />
            <SafetyBriefing />
        </>
    );

    const sections = [
        {
            id: 'ops',
            label: 'Ops',
            lines: [
                { id: 'Briefings', label: 'Active', component: CurrentBriefing },
                { id: 'Old Briefings', label: 'Archives', component: ArchivesWrapper },
            ],
        },
        {
            id: 'safety',
            label: 'Safety',
            lines: [
                { id: 'Briefings', label: 'Active', component: SafetyBriefing },
                { id: 'Old Briefings', label: 'Archives', component: SafetyBriefingWrapper },
            ],
        },
    ];

    return (
        <>
            <Toaster position='bottom-right' />
            <div className="briefing-top-toolbar">
                <div
                    className={`toolbar-section ${briefing.section === 'ops' ? 'active' : ''}`}
                >
                    <div className="section-header">
                        <span>Ops</span>
                        <div className="section-buttons">
                            <button
                                onClick={() => handleBriefingClick({ section: 'ops', line: 'Briefings' })}
                                className={`toolbar-button ${briefing.line === 'Briefings' ? 'active' : ''}`}
                                aria-current={briefing.line === 'Briefings' ? 'true' : 'false'}
                            >
                                Active
                            </button>
                            <button
                                onClick={() => handleBriefingClick({ section: 'ops', line: 'Old Briefings' })}
                                className={`toolbar-button ${briefing.line === 'Old Briefings' ? 'active' : ''}`}
                                aria-current={briefing.line === 'Old Briefings' ? 'true' : 'false'}
                            >
                                Archives
                            </button>
                        </div>
                    </div>
                </div>

                <div
                    className={`toolbar-section ${briefing.section === 'safety' ? 'active' : ''}`}
                >
                    <div className="section-header">
                        <span>Safety</span>
                        <div className="section-buttons">
                            <div
                                className={`toolbar-button ${briefing.line === 'Briefings' ? 'active' : ''}`}
                                aria-current={briefing.line === 'Briefings' ? 'true' : 'false'}
                                onClick={() => handleBriefingClick({ section: 'safety', line: 'Briefings' })}
                            >
                                <button
                                    className={`toolbar-button`}
                                    style={{
                                        fontWeight: (briefing.section === 'safety' && briefing.line === 'Briefings') ? 'bold' : ''
                                    }}
                                onClick={() => {
                                    dispatch(setCurrentTerminal(null))
                                }}
                                >
                                    Active
                                </button>
                                {
                                    terminals && terminals.length > 0 && (
                                        <div className='d-inline flex flex-wrap justify-content-center ml-1'>
                                            {terminals.map((terminal) => (
                                                <button
                                                    onClick={() => terminal.id !== currentTerminal?.id ? dispatch(setCurrentTerminal(terminal)) : dispatch(setCurrentTerminal(null))}
                                                    active={currentTerminal?.id === terminal.id ? 'true' : 'false'}
                                                    key={terminal.id}
                                                    className={`terminal-select-button ${terminal.short_form_name}-button`}
                                                >
                                                    {terminal.short_form_name}
                                                </button>
                                            ))}
                                        </div>
                                    )
                                }
                            </div>
                            <button
                                onClick={() => handleBriefingClick({ section: 'safety', line: 'Old Briefings' })}
                                className={`toolbar-button ${briefing.line === 'Old Briefings' ? 'active' : ''}`}
                                aria-current={briefing.line === 'Old Briefings' ? 'true' : 'false'}
                            >
                                Archives
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="briefing-content">
                {sections.map((section) =>
                    section.lines.map((line) =>
                        briefing.section === section.id && briefing.line === line.id ? (
                            <line.component key={`${section.id}-${line.id}`} />
                        ) : null
                    )
                )}
            </div>
        </>
    );
};

export default Briefing;